var map = {
	"./book-solid.svg": "6537",
	"./building-shield-solid.svg": "7c7f",
	"./building-user-solid.svg": "e214",
	"./calendar-solid.svg": "45ad",
	"./cart-shopping-solid.svg": "de3c",
	"./chart-line-solid.svg": "c84b",
	"./city-solid.svg": "63a1",
	"./crosshairs-solid.svg": "9fe5",
	"./file-lines-solid.svg": "7247",
	"./gauge-solid.svg": "08dd",
	"./gears-solid.svg": "02ef",
	"./gifts-solid.svg": "d3eb",
	"./line-brands-solid.svg": "ff16",
	"./receipt-solid.svg": "770f",
	"./sliders-solid.svg": "0cdc",
	"./store-solid.svg": "5ee9",
	"./trophy-solid.svg": "05c9",
	"./user-shield-solid.svg": "94f6",
	"./users-gear-solid.svg": "7302",
	"./users-solid.svg": "076e",
	"./wand-magic-sparkles-solid.svg": "b48d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3063";